import {
  Card,
  CardBody,
  CardHeader,
  CircularProgress,
  Flex,
  Heading,
  HStack,
  Icon,
  IconButton,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa6';
import { FiEdit2, FiSend, FiTrash2 } from 'react-icons/fi';
import { PiNewspaperClipping } from 'react-icons/pi';
import ProtectedButton from 'shared/components/ProtectedButton';
import { usePermissions } from 'shared/hooks/usePermissions';
import { useBulletinContext } from './BulletinContext';
import BulletinFormModal from './components/BulletinFormModal';
import BulletinResendModal from './components/BulletinResendModal';

const Bulletin = () => {
  const { d } = usePermissions();
  const {
    bulletins,
    loading,
    isRegistered,
    formBulletin,
    isFormOpen,
    openCreateForm,
    openEditForm,
    closeForm,
    isResendOpen,
    openResendForm,
    closeResendForm,
    handleDelete,
  } = useBulletinContext();

  return (
    <Card>
      <BulletinFormModal
        isOpen={isFormOpen}
        bulletin={formBulletin}
        onClose={closeForm}
      />
      <BulletinResendModal isOpen={isResendOpen} onClose={closeResendForm} />

      <CardHeader>
        <HStack>
          <Icon as={PiNewspaperClipping} />
          <Heading size="sm">Boletim</Heading>

          <ProtectedButton
            permission="installation-card-bulletin-create"
            isDisabled={loading || !isRegistered || bulletins.length === 0}
            leftIcon={<FiSend />}
            onClick={openResendForm}
            variant="outline"
            size="sm"
            py="1.5rem"
            ml="auto"
          >
            Reenviar
          </ProtectedButton>

          <ProtectedButton
            permission="installation-card-bulletin-create"
            isDisabled={loading}
            leftIcon={<FaPlus />}
            onClick={openCreateForm}
            variant="filled"
            size="sm"
            py="1.5rem"
          >
            Adicionar
          </ProtectedButton>
        </HStack>
      </CardHeader>

      <CardBody>
        {isRegistered ? (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th textAlign="center">Nome</Th>
                  <Th textAlign="center">Telefone</Th>
                  <Th textAlign="center">Empresa</Th>
                  <Th textAlign="center">Status</Th>
                  <Th textAlign="center">Ações</Th>
                </Tr>
              </Thead>
              <Tbody>
                {loading ? (
                  <Tr>
                    <Td colSpan={5}>
                      <Flex justify="center" py="1rem">
                        <CircularProgress isIndeterminate color="yooga.400" />
                      </Flex>
                    </Td>
                  </Tr>
                ) : bulletins.length === 0 ? (
                  <Tr>
                    <Td colSpan={5}>
                      <Text textAlign="center" color="gray.500" py="1rem">
                        Nenhum boletim encontrado.
                      </Text>
                    </Td>
                  </Tr>
                ) : (
                  bulletins.map((bulletin) => (
                    <Tr key={bulletin.id}>
                      <Td textAlign="center">{bulletin.ownerName}</Td>
                      <Td textAlign="center">{bulletin.phone}</Td>
                      <Td textAlign="center">{bulletin.companyName}</Td>
                      <Td textAlign="center">
                        <Tag colorScheme={bulletin.active ? 'green' : 'red'}>
                          {bulletin.active ? 'Ativo' : 'Inativo'}
                        </Tag>
                      </Td>
                      <Td textAlign="center">
                        <HStack justify="center">
                          <IconButton
                            rounded="full"
                            variant="ghost"
                            aria-label="Editar boletim"
                            icon={<FiEdit2 />}
                            size="sm"
                            isDisabled={d('installation-card-bulletin-update')}
                            onClick={() => openEditForm(bulletin)}
                          />
                          <IconButton
                            rounded="full"
                            variant="ghost"
                            aria-label="Excluir boletim"
                            icon={<FiTrash2 />}
                            size="sm"
                            colorScheme="red"
                            isDisabled={d('installation-card-bulletin-delete')}
                            onClick={() => handleDelete(bulletin.id)}
                          />
                        </HStack>
                      </Td>
                    </Tr>
                  ))
                )}
              </Tbody>
            </Table>
          </TableContainer>
        ) : (
          <Text fontWeight="500" color="gray.500">
            Nenhum boletim encontrado.
          </Text>
        )}
      </CardBody>
    </Card>
  );
};

export default Bulletin;
